<template>
  <div class="relative bg-gray-300 rounded overflow-hidden">
    <div
        class="shimmer absolute top-0 right-0 bottom-0 left-0"
        :style="shimmerStyle"
    ></div>

    <div
        v-if="$slots.default"
        class="absolute left-1/2 top-1/2 translate-x-1/2 -translate-y-1/2 grid place-content-center"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const shimmerStyle = computed(() => {
  const rgb = '#ffffff'

  return {
    backgroundImage: `linear-gradient(90deg, rgba(${rgb}, 0) 0%, rgba(${rgb}, 0.2) 20%, rgba(${rgb}, 0.5) 60%, rgba(${rgb}, 0))`
  }
})
</script>

<style scoped>
.shimmer {
  transform: translateX(-100%);
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
